module.exports = __webpack_public_path__ + "img/2-on.a32a13b6.png";